import { stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, fonts } = theme;

export const resetButton = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  margin: ${stack(spacing.xl)};
`;
